/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 10:06:10
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-15 18:06:07
 */
const langLabels = {
  menu: {},
  role: {
    successTips: '操作成功'
  },
  interface: {
    apiName: '接口名称',
    apiUrl: '接口地址',
    perms: '权限标识',
    remark: '接口描述',
    state: '状态',
    createTime: '创建时间',
    createBy: '创建人',
    updateBy: '更新人',
    updateTime: '更新时间',
    apiNamePlaceholder: '请输入接口名称',
    apiUrlPlaceholder: '请选择接口地址',
    statePlaceholder: '请选择状态',
    permsPlaceholder: '请选择权限标识',
    remarkPlaceholder: '请输入接口描述',
    endTimeplaceholder: '结束时间',
    startTimeplaceholder: '开始时间',
    deptCodePlaceholder: '请输入部门编码',
    deptCode: '部门编码',
    submit: '提交',
    save: '保存',
    cancle: '取消',
    addTitle: '新增',
    editTitle: '修改',
    infoTitle: '详情',
    all: '全部',
    parentId: '上级模块',
    parentIdPlaceholder: '请选择上级模块',
    moduleName: '模块名称',
    moduleNamePlaceholder: '请输入模块名称',
    public: '是否发布',
    publicPlaceholder: '请选择是否发布',
    apiType: '类型',
    apiTypePlaceholder: '请选择类型',
    developer: '开发人员',
    developerPlaceholder: '请输入开发人员'
  }
}
export default langLabels
